import * as THREE from "three";
import { setIntersectsObjects } from "./raycaster.js";
import { resetForm } from "./applyFormData.js";
import { setCameraOnEditMode, setCameraOnRoom } from "./setUpCamera.js";
import { applyRoomLighting, applyConfiguratorLighting } from "./scene.js";
import { openCorrectSideMenu } from "./dynamicLoader.js";
import { resetShelfBlocks } from "./addShelfBlock.js";
import { resetCalculator, restoreCalcActives, setCalcValueIbUserData } from "./calculator.js";
import { hideAndRemove } from "./changeObjectParams/helpers";
import { makeObjectScreenshot } from "./screenshot.js";
import { createObjToSave } from "./saveLoad.js";
import { deepCloneWithoutKey } from "../helpers/deepCloneWithoutKey.js";
import { changeTableColor } from "./changeObjectParams/changes/tables/down/down.js";
import { getActiveHitbox } from "./getActiveHitbox.js";
import { closeLocalPreloader, openLocalPreloader } from "./modals.js";
import { cardItems } from "./vars/cardItems/index.js";
import { getTableName } from "../helpers/getTableName.js";
import { extractSize } from "../helpers/extractSize.js";
import { addObjectToScene } from "./addObjectToScene.js";
import { html } from "../helpers/stringHTML.js";
import { openAccordion } from "./accordions.js";
import { closeMenu } from "../helpers/closeMenu.js";
import { initDoorAnimation, toggleDoorsHandler } from "./doorAnimationStore.js";
import { setVisibleSpriteTextInObj } from "../helpers/setVisibleSpriteTextInObj.js";
import { makeCSS2Dannotaition } from "./annotations.js";
import { Vector3 } from "three";

const assistBtns = document.querySelector(".assist_btns");

export function addCards() {
    let cardItemElems = Object.entries(cardItems[servObj.targetPageKey]);
    cardItemElems.forEach(([selector, arrData]) => {
        const menu = document.querySelector(".menu");
        if (!menu) {
            console.error("[addCards] Меню не было найдено в DOM-дереве");
            return;
        }

        const accordionsWrap = menu.querySelector(".accordions_wrap");
        if (!accordionsWrap) {
            console.error('[addCards] Блок с селектором ".accordions_wrap" не был найден в DOM-дереве');
            return;
        }

        const allAccordions = Array.from(accordionsWrap.querySelectorAll(".accordion"));
        // // Сначала скрываем все аккордеоны
        // allAccordions.forEach((el) => el.classList.remove("d-none"));

        // const accordion = allAccordions.find((el) => el.classList.contains(selector));
        const accordion = allAccordions.find((el) => el.classList.contains(selector));
        if (!accordion) {
            console.error(`[addCards] Аккордеон с селектором ".${selector}" не был найден в DOM-дереве`);
            return;
        }
        // if (arrData.length === 0) {
        //     accordion.classList.add("d-none");
        // }

        // У стеллажей скрываем конструкционный профиль, но закомментированный и более универсальный вариант (скрываем те, у которых нет карточек) на рассмотрении!!!
        if (
            (servObj.targetPageKey === "stellazhi" && selector === "construct_type") ||
            (servObj.targetPageKey === "wardrobes" && selector === "construct_type")
        ) {
            accordion.classList.add("d-none");
        }

        let cardItemElem = document.querySelector(`.${selector} .card_items`);
        if (!cardItemElem) return;

        // accordion.classList.add("d-none");
        // if (arrData.length === 0) {
        //     cardItemElem.classList.add("d-none");
        // }

        arrData.forEach((data) => {
            let div = document.createElement("div");
            div.className = `card ${data.actual ? "" : "d-none"}`;
            data.name && (div.dataset.objectName = data.name);
            data.menuTitle && (div.dataset.menuTitle = data.menuTitle);
            data.nextMenu && (div.dataset.nextMenu = data.nextMenu);
            data.glbName && (div.dataset.glbName = data.glbName);
            data.allArrTable && (div.dataset.allArrTable = data.allArrTable);
            data.tempName && (div.dataset.tempName = data.tempName);
            data.pageName && (div.dataset.pageName = data.pageName);
            data.glbPath && (div.dataset.glbPath = data.glbPath);
            data.folderName && (div.dataset.folderName = data.folderName);
            data.typeName && (div.dataset.typeName = data.typeName);
            data.defaultWidth && (div.dataset.defaultWidth = data.defaultWidth);
            data.defaultDepth && (div.dataset.defaultDepth = data.defaultDepth);
            data.wardrobeType && (div.dataset.wardrobeType = data.wardrobeType);

            const titleText = data.title ? data.title.replace(/<br\s*\/?>/gi, "") : "";
            div.innerHTML = html`
                <div class="card_img">
                    <img
                        src="./images/${data.imgName ? "items/" + selector + "/" + data.imgName : "icons/image.svg"}"
                        alt="Image"
                    />
                </div>
                <div class="card_text" title="${titleText}">
                    <p class="truncate-multiline" data-lines="2">${data.title}</p>
                </div>
            `;
            cardItemElem.append(div);
        });
    });

    let cards = document.querySelectorAll(".card[data-object-name]");
    cards.forEach((card) => {
        let objectName = card.dataset.objectName;
        let glbPath = card.dataset.glbPath;
        let glbName = card.dataset.glbName;
        let allArrTable = card.dataset.allArrTable;
        let tempName = card.dataset.tempName;
        let pageName = card.dataset.pageName;
        let folderName = card.dataset.folderName;
        let typeName = card.dataset.typeName;
        let defaultWidth = card.dataset.defaultWidth;
        let defaultDepth = card.dataset.defaultDepth;
        let wardrobeType = card.dataset.wardrobeType;

        const objectSize = extractSize(objectName);
        const objectWidth = (objectSize && Number(objectSize.split("x")[0])) || 0;
        const objectDepth = (objectSize && Number(objectSize.split("x")[1])) || 0;

        if (!objectName) return;
        const loadData = {
            objectName,
            glbPath,
            glbName,
            allArrTable,
            tempName,
            objectWidth,
            objectDepth,
            pageName,
            folderName,
            typeName,
            defaultWidth,
            defaultDepth,
            wardrobeType,
        };
        card.addEventListener("click", async () => {
            openLocalPreloader();
            await new Promise((resolve) => {
                setTimeout(resolve, 1500);
            });
            servObj.tempName = tempName;
            resetCalculator();

            console.log({ loadData });

            const tableName = getTableName(loadData);

            loadData.calcActives = {
                [tableName]: {
                    piece: 1,
                },
            };
            clearActiveArrays();
            await addObjectToScene(loadData, tableName);
            const nextMenu = card.dataset.nextMenu;
            const menuTitle = card.dataset.menuTitle;
            await openCorrectSideMenu(nextMenu, menuTitle);
            resetShelfBlocks();
            servObj.tableColor.changeable_kromka_material.current =
                servObj.tableColor.changeable_kromka_material.default;
            servObj.tableColor.changeable_painted_metal_material.current =
                servObj.tableColor.changeable_painted_metal_material.default;
            changeTableColor(
                "changeable_painted_metal_material",
                servObj.tableColor.changeable_painted_metal_material.current,
            );
            changeTableColor("changeable_kromka_material", servObj.tableColor.changeable_kromka_material.current);
            closeLocalPreloader();

            if (servObj.isMobile) {
                closeMenu({ instant: true });
            }
        });
    });

    // Если аккордеон только 1, то сразу открываем его
    const accordions = document.querySelectorAll(".accordion:not(.d-none)");
    if (accordions.length === 1) openAccordion(document.querySelector(".accordion"));
}

function getBottomElementsBoundingBox(objectsArray) {
    const box = new THREE.Box3();

    objectsArray.forEach((obj) => {
        if (!(obj instanceof THREE.Object3D)) return;

        obj.updateWorldMatrix(true, true);

        obj.traverse((child) => {
            if (!child.isMesh) return;
            expandByMorphMesh(box, child);
        });
    });

    const size = new THREE.Vector3();
    box.getSize(size);

    const center = new THREE.Vector3();
    box.getCenter(center);

    return { box, size, center };
}

const doorAnimateBtn = document.getElementById("animate-doors");

export function expandByMorphMesh(box, mesh) {
    const position = mesh.geometry.attributes.position;
    const morphs = mesh.geometry.morphAttributes.position;

    if (!morphs || morphs.length === 0) {
        box.expandByObject(mesh);
        return;
    }

    const temp = new THREE.Vector3();

    for (let i = 0; i < position.count; i++) {
        temp.fromBufferAttribute(position, i);

        morphs.forEach((morphAttr, index) => {
            const influence = mesh.morphTargetInfluences[index];
            if (!influence) return;

            const morph = new THREE.Vector3().fromBufferAttribute(morphAttr, i);
            temp.addScaledVector(morph, influence);
        });

        temp.applyMatrix4(mesh.matrixWorld);
        box.expandByPoint(temp);
    }
}

export async function addObjectOnRoom() {
    if (servObj.isRedactorMode === false && !servObj.redactorModeObject) return;

    if (
        servObj.activeWardrobeDoors &&
        servObj.activeWardrobeDoors.length > 0 &&
        servObj.redactorModeObject.userData.loadData.folderName === "wardrobes"
    ) {
        toggleDoorsHandler({ target: doorAnimateBtn, shouldBeOpen: false, durationAnimation: 0 }); // закрываем двери без анимации
    }

    // Выключаем SpriteText:
    setVisibleSpriteTextInObj({ targetObject: servObj.redactorModeObject, visible: false });

    // СОХРАНИМ ВЫБРАННЫЙ ЦВЕТ СТОЛА В USER DATA
    servObj.redactorModeObject.userData.colors = {
        changeable_kromka_material: servObj.tableColor.changeable_kromka_material.current,
        changeable_painted_metal_material: servObj.tableColor.changeable_painted_metal_material.current,
    };

    const isTable = servObj.redactorModeObject.userData.loadData.folderName === "tables";

    const menu_title = document.querySelector(".menu_title").textContent || "";
    const table_name = isTable
        ? servObj.redactorModeObject.name.split("__")[0] || "bazovii"
        : servObj.redactorModeObject.name.split("__")[1] || "sop";
    servObj.redactorModeObject.userData.menu_title = menu_title;

    const isInstrumentalniyShkaf = servObj.tempName === "instrumentalniy";

    servObj.redactorModeObject.userData.side_menu = isTable ? `table_${table_name}` : table_name;

    if (isInstrumentalniyShkaf) {
        servObj.redactorModeObject.userData.side_menu = "instrumentalniy";
    }

    let screenshot = null;
    try {
        screenshot = await makeObjectScreenshot();
        if (!screenshot) throw new Error("Скриншот вернул null");
        servObj.redactorModeObject.userData.screenshot = screenshot;
    } catch (e) {
        console.error("Ошибка при создании скриншота:", e);
        return;
    }
    const rawSaveObjToJson = await createObjToSave();
    const saveObjToJson = deepCloneWithoutKey(rawSaveObjToJson, "saveObjToJson");

    // теперь можно вложить безопасно
    servObj.redactorModeObject.userData.saveObjToJson = saveObjToJson;
    addActiveObjectInTable();
    servObj.isRedactorMode = false;
    servObj.isEditMode = false;
    setCameraOnRoom();
    servObj.building.addObject(servObj.redactorModeObject);
    setIntersectsObjects([...servObj.building._all, ...servObj.building.walls, servObj.building.floor]);
    const elementsForCalculation = servObj.redactorModeObject.children.filter(
        (obj) => obj.userData.isBottom && !obj.isSprite,
    );

    // 1. bbox по XZ только по нижним элементам
    const bottomBBox = getBottomElementsBoundingBox(elementsForCalculation);

    // 2. bbox по Y по всему объекту
    const objHeight = servObj.building.getBoundaryGeometry(servObj.redactorModeObject).y;

    // 3. Переместить пивот по XZ в центр нижних элементов
    recenterObjectPivotXZToPoint(servObj.redactorModeObject, bottomBBox.center);

    // Сохраняем исходные позиции детей и позицию стола
    if (servObj.redactorModeObject) {
        if (!servObj.redactorModeObject.userData.initialChildrenPositionsXZ) {
            servObj.redactorModeObject.userData.initialChildrenPositionsXZ = servObj.redactorModeObject.children.map(
                (child) => ({
                    x: child.position.x,
                    z: child.position.z,
                }),
            );
        }
        if (!servObj.redactorModeObject.userData.initialParentPositionXZ) {
            servObj.redactorModeObject.userData.initialParentPositionXZ = {
                x: servObj.redactorModeObject.position.x,
                z: servObj.redactorModeObject.position.z,
            };
        }
    }
    const zOffset = servObj.redactorModeObject.userData.initialChildrenPositionsXZ?.length
        ? Math.abs(servObj.redactorModeObject.userData.initialChildrenPositionsXZ[0].z)
        : 0;
    const xOffset = servObj.redactorModeObject.userData.initialChildrenPositionsXZ?.length
        ? Math.abs(servObj.redactorModeObject.userData.initialChildrenPositionsXZ[0].x)
        : 0;

    if (!servObj.redactorModeObject.userData.editModePos) {
        servObj.redactorModeObject.userData.editModePos = new Vector3(0, 10, 0);
    }
    servObj.redactorModeObject.userData.editModePos.z = zOffset;
    servObj.redactorModeObject.userData.editModePos.x = xOffset;

    // 4. Размеры: X и Z — по нижним, Y — по всему объекту
    servObj.redactorModeObject.userData.bSize = new THREE.Vector3(bottomBBox.size.x, objHeight, bottomBBox.size.z);
    if (servObj.rememberedPosition) servObj.redactorModeObject.position.copy(servObj.rememberedPosition);
    if (servObj.rememberedRotation) {
        servObj.redactorModeObject.rotation.copy(servObj.rememberedRotation);

        // Получаем угол поворота по Y в градусах
        const yDeg = THREE.MathUtils.radToDeg(servObj.rememberedRotation.y) % 360;
        const absYDeg = Math.abs(yDeg);
        const EPSILON = 0.1;

        // Проверяем, что угол близок к 90, 270, 450 и т.д., но не к 0, 180, 360 и т.д.
        if (Math.abs((absYDeg % 180) - 90) < EPSILON) {
            // Меняем местами X и Z в bSize
            const bSize = servObj.redactorModeObject.userData.bSize;
            if (bSize && bSize instanceof THREE.Vector3) {
                const temp = bSize.x;
                bSize.x = bSize.z;
                bSize.z = temp;
            }
        }
    }

    servObj.redactorModeObject.position.y = 0;

    servObj.rememberedPosition = null;
    servObj.rememberedRotation = null;
    const event = new Event("pointerdown");
    const button = document.querySelector(".view2d3d .active");
    button.dispatchEvent(event);
    document.querySelector(".view2d3d").classList.remove("hide");
    document.querySelector(".sizes").classList.remove("hide");
    assistBtns.classList.remove("hide");
    openCorrectSideMenu("main_btns");

    document.querySelector(".add_in_room_btn_wrap").classList.add("hide");
    document.querySelector(".animate-doors_btn_wrap").classList.add("hide");

    servObj.building._dragControls.enabled = true;
    servObj.active = servObj.redactorModeObject;
    servObj.building.checkCollision();
    servObj.guideLines.recalculateLinesPosition(
        servObj.redactorModeObject,
        servObj.guideLines.findNeighbours(servObj.redactorModeObject),
    );
    servObj.guideLines.showLines();
    if (
        servObj.building._objects.length >= 0 ||
        servObj.building._objects.some((el) => {
            el.name !== servObj.redactorModeObject.name;
        })
    ) {
        saveAllCheckedInputsInUserData();
        // servObj.allTableInRoom.push(servObj.active);
        resetForm("form-object-params"); // Сбрасываем форму после добавления объекта;
    }
    servObj.building._cutColumnSizeByBuildingSize(servObj.redactorModeObject);
    setCalcValueIbUserData(servObj.redactorModeObject);
    applyRoomLighting();
    servObj.building._vertical_only = [];
    servObj.redactorModeObject = null;
}
export async function editObject() {
    if (servObj.isRedactorMode === true || !servObj.active || servObj.active.name === "column") return;

    // Выключаем SpriteText:
    setVisibleSpriteTextInObj({ targetObject: servObj.active, visible: false });

    servObj.isEditMode = true;
    servObj.isRedactorMode = true;
    servObj.redactorModeObject = {};
    servObj.redactorModeObject = servObj.active;
    servObj.tempName = servObj.redactorModeObject.userData.loadData.tempName;
    servObj.building._missClick();

    const saveChangeBtn = document.getElementById("add_in_room_btn");
    saveChangeBtn.parentNode.classList.remove("hide");
    saveChangeBtn.textContent = "Сохранить изменения";

    const isWardrobe = servObj.redactorModeObject.userData.loadData.folderName === "wardrobes";
    if (isWardrobe) document.querySelector(".animate-doors_btn_wrap").classList.remove("hide");

    applyConfiguratorLighting();

    setCameraOnEditMode(servObj.active);
    servObj.active = null;

    const menu_title = servObj.redactorModeObject.userData.menu_title;
    const side_menu = servObj.redactorModeObject.userData.side_menu;
    await openCorrectSideMenu(side_menu, menu_title);
    restoreCalcActives();
    document.querySelector(".view2d3d").classList.add("hide");
    document.querySelector(".sizes").classList.add("hide");
    assistBtns.classList.add("hide");
    document.querySelector(".back_btn")?.classList.add("hide");
    servObj.building._dragControls.enabled = true;

    setTimeout(() => {
        getActiveHitbox();
        servObj.building.checkCollision();
    }, 50);

    if (servObj.activeWardrobeDoors && servObj.activeWardrobeDoors.length > 0) {
        servObj.activeWardrobeDoors.forEach((el) => initDoorAnimation(el, false));

        toggleDoorsHandler({ target: doorAnimateBtn, shouldBeOpen: true, durationAnimation: 0 }); // открываем двери без анимации
    }

    makeCSS2Dannotaition(servObj.redactorModeObject);
}
function addActiveObjectInTable() {
    // Собираем все массивы из servObj, чьи ключи начинаются с "active"
    const childrenArrays = Object.keys(servObj)
        .filter((key) => key.startsWith("active") && !key.includes("activeHitbox") && Array.isArray(servObj[key]))
        .map((key) => servObj[key]);

    // Собираем всех детей из этих массивов в один плоский массив
    const addObjects = [].concat(...childrenArrays);

    // Берём целевой объект в режиме редактирования
    const target = servObj.redactorModeObject;
    // Для каждого объекта переводим глобальные координаты в локальные относительно target и добавляем в target
    addObjects.forEach((obj) => {
        if (target.name === obj.name) return;
        obj.userData.editModePos = obj.position.clone();

        // Добавляем объект в target
        target.attach(obj);
    });
    Object.keys(servObj)
        .filter((key) => key.startsWith("active") && Array.isArray(servObj[key]))
        .forEach((key) => {
            servObj[key] = [];
        });
}
export function restoreActiveArrays(targetObj) {
    if (!targetObj) return;

    // Сохраняем локальные трансформации родителя
    const savedPosition = new THREE.Vector3(
        targetObj.userData.editModePos.x,
        targetObj.userData.editModePos.y,
        targetObj.userData.editModePos.z,
    );

    // Создаём копию массива детей для безопасной итерации
    const children = Array.from(targetObj.children);
    children.forEach((el) => {
        if (!el.userData?.allFolderName || !el.userData?.activeFolderName) return;
        const {
            activeFolderName: activeArrayName,
            allFolderName: arrayName,
            verticalOnly,
            horizontalOnly,
        } = el.userData;
        const elName = el.name;

        // Сохраняем мировые позицию и вращение элемента
        const worldPosition = new THREE.Vector3();
        const worldQuaternion = new THREE.Quaternion();
        el.getWorldPosition(worldPosition); // Автоматически обновляет матрицы
        el.getWorldQuaternion(worldQuaternion);

        // Удаляем элемент из текущего родителя
        targetObj.remove(el);

        // Добавляем элемент в сцену
        servObj.scene.add(el);

        // Применяем мировые трансформации как локальные относительно сцены
        el.position.copy(el.userData.editModePos);
        el.quaternion.copy(worldQuaternion);
        el.updateMatrixWorld();

        //Собираем ссылки на HITBOX
        const availableChildrenNameSet = new Set(
            servObj.redactorModeObject.userData.saveObjToJson.elements.map((e) => e.name),
        );
        el.traverse((child) => {
            if (!child.name) return;
            if (!child.name.endsWith("__hitbox")) return;
            const nameToCheck = child.name.replace(/__hitbox$/, "");
            if (availableChildrenNameSet.has(nameToCheck)) {
                servObj.activeHitbox.push(child);
            }
        });
        if (el.userData?.visibleChildren?.length) {
            el.userData.visibleChildren.forEach((item) => {
                el.traverse((ch) => {
                    if (ch.name.includes(item) && ch.name.includes("hitbox")) servObj.activeHitbox.push(ch);
                });
            });
        }

        // Логика распределения по массивам
        if (servObj[arrayName]) {
            const found = servObj[arrayName].find((item) => elName.includes(item.name));
            if (found) {
                servObj[activeArrayName].push(el);
            }
        }
        if (verticalOnly) {
            servObj.building.addVerticalObj(el);
        }
        if (horizontalOnly) {
            servObj.building.addHorizontalObj(el);
        }
    });

    // Восстанавливаем трансформации родителя
    // recenterObejctPivotXZ(servObj.redactorModeObject);
    targetObj.position.copy(savedPosition);
}
function recenterObjectPivotXZToPoint(obj, centerXZ) {
    if (!obj) return;
    if (!obj.userData.initialPivotWorld) {
        const pivot = new THREE.Vector3();
        obj.getWorldPosition(pivot);
        obj.userData.initialPivotWorld = pivot.clone();
    }
    obj.updateMatrixWorld(true);

    // Получаем текущую мировую позицию пивота
    const oldPivotWorld = new THREE.Vector3();
    obj.getWorldPosition(oldPivotWorld);

    // Новый центр только по XZ, Y оставляем прежним
    const newCenterWorld = new THREE.Vector3(centerXZ.x, oldPivotWorld.y, centerXZ.z);

    // Переводим в локальные координаты родителя
    const parent = obj.parent;
    if (parent) {
        const invParentMatrix = new THREE.Matrix4().copy(parent.matrixWorld).invert();
        newCenterWorld.applyMatrix4(invParentMatrix);
    }
    obj.position.set(newCenterWorld.x, newCenterWorld.y, newCenterWorld.z);
    // obj.userData.editModePos.x = obj.userData.initialPivotWorld.x;

    // Смещаем детей обратно
    const shift = {
        x: centerXZ.x - oldPivotWorld.x,
        z: centerXZ.z - oldPivotWorld.z,
    };
    obj.children.forEach((child) => {
        child.position.x -= shift.x;
        child.position.z -= shift.z;
    });
    obj.updateMatrixWorld(true);
}
export function clearActiveArrays() {
    // Очищаем все массивы, начинающиеся с "active"
    Object.keys(servObj)
        .filter((key) => key.startsWith("active") && Array.isArray(servObj[key]))
        .forEach((key) => {
            if (servObj[key].length) {
                servObj[key].forEach((elem) => hideAndRemove(elem));
                servObj[key] = [];
            }
        });
}
export function saveAllCheckedInputsInUserData() {
    const servObj = window.servObj || parent.servObj;
    let form = document.getElementById("form-object-params") || parent.document.getElementById("form-object-params");
    if (!form) {
        console.warn("Не удалось сохранить данные формы в userData, так как форма не была найдена!");
        return;
    }
    const checkedInputs = form.querySelectorAll("input:checked, input[type='text']");
    const checkedInputsData = Array.from(checkedInputs)
        .filter(
            (input) =>
                input.name !== "change_elems" &&
                input.name !== "dop_oborudovanie" &&
                !input.name.includes("table_position"),
        )
        .map((input) => ({
            name: input.name,
            value: input.value,
        }));
    servObj.redactorModeObject.userData.checkedInputsData = checkedInputsData;
}
